import { forwardRef } from 'react';
import { useReactDndConstructs } from '../../../../dnd/ReactDndContext';
import { DragPreview } from '../../../../dnd/view/DragPreview';
import { jsx as _jsx } from "react/jsx-runtime";
export const SectionDragPreview = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    useDragLayer
  } = useReactDndConstructs();
  const {
    item,
    itemType
  } = useDragLayer(monitor => ({
    item: monitor.getItem(),
    itemType: monitor.getItemType()
  }));
  const renderItem = () => {
    if (!item || item.dndPrefix !== props.dndPrefix) return null;
    switch (itemType) {
      case props.dragType:
        return props.children(item.index);
      default:
        return null;
    }
  };
  return /*#__PURE__*/_jsx(DragPreview, {
    ref: ref,
    style: {
      ...props.style
    },
    children: renderItem()
  });
});
//# sourceMappingURL=SectionDragPreview.js.map